const {h, render, Component} = require('preact');
const WidgetsContainer = require('../../containers/main/widgets')

class ThankYouPageView extends Component {
  constructor(props) {
    super(props);
  };

  getChannelText(channel, I18n) {
    switch(channel) {
      case 'email':
        return (
          <div class="thanks-text">
            <span>{I18n.t('js.modules.web_2018.thank_you_email_text_1')}</span>
            <br/>
            <span>{I18n.t('js.modules.web_2018.thank_you_email_text_2')}</span>
          </div>
        )
      case 'ssor_email':
        return (
          <div class="thanks-text">
            <span>{I18n.t('js.modules.web_2018.thank_you_ssor_email_text_1')}</span>
            <br/>
            <span>{I18n.t('js.modules.web_2018.thank_you_ssor_email_text_2')}</span>
          </div>
        )
      case 'chat':
        return (
          <div class="thanks-text">
            {I18n.t('js.modules.web_2018.thank_you_chat_text')}
          </div>
        )
      case 'phone':
        return (
          <div class="thanks-text">
            {I18n.t('js.modules.web_2018.thank_you_phone_text')}
          </div>
        )
      case 'refund':
        return (
          <div class="thanks-text">
            <span>{I18n.t('js.modules.touch_v2.refund_thank_you')}</span>
            <br/>
            <span>{I18n.t('js.modules.touch_v2.refund_email_sent')}</span>
          </div>
        )

      default:
        return null;
    }
  }

  componentDidUpdate() {
    if(Groupon.Utils)
      Groupon.Utils.lazyLoadImages()
    window.cardUI.init()
  }

  hideHeaderBannerIfPresent() {
    var headerBanner = document.getElementById("header-banner")
    if (headerBanner)
      headerBanner.setAttribute("style", "display:none")
  }

  returnPageInfo(channel) {
    let data = {};
    switch (channel) {
      case 'refund': {
        data.url = "/"
        data.text = I18n.t('js.modules.touch_v2.continue_shopping')
        return data
      }
      default: {
        data.url = "/customer_support"
        data.text = I18n.t('js.modules.web_2018.return_to_support_page')
        return data
      }
    }
  }

  render() {
    this.hideHeaderBannerIfPresent();
    let channel = this.props.channel
    let returnPageInfo = this.returnPageInfo(channel);
    if(document.getElementById('breadcrumbs'))
      document.getElementById('breadcrumbs').style.display='none'
    return (
      <section className="main row cs_support_header" id="contact-us-body-content">
        <div className="twelve columns">
          <section className="module">
            <div className="module-body contact-us">
              <div className="row">
                <div class ="thank_you">
                  { channel &&
                    <div class="message ticket-success-message">
                      <div class="icon-check-circle"> </div>
                      <div class="thanks-for-contacting">
                        {I18n.t('js.modules.web_2018.thank_you')}
                      </div>
                      {this.getChannelText(channel, I18n)}
                      <div class="return_to_support_page">
                        <a href={returnPageInfo.url} class="btn btn-large" data-bhw="web_2018_thank_you_return_to_support_page">
                          {returnPageInfo.text}
                        </a>
                      </div>
                    </div>
                  }
                  <WidgetsContainer/>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
    );
  }
}

module.exports = ThankYouPageView
